export default __webpack_public_path__ + "static/media/stavme-sa.ae73fe73.svg";